import { render, staticRenderFns } from "./SettleFbpClaimsEmplPage.vue?vue&type=template&id=13392ebb&scoped=true"
import script from "./SettleFbpClaimsEmplPage.vue?vue&type=script&lang=js"
export * from "./SettleFbpClaimsEmplPage.vue?vue&type=script&lang=js"
import style0 from "./SettleFbpClaimsEmplPage.vue?vue&type=style&index=0&id=13392ebb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13392ebb",
  null
  
)

export default component.exports